<div 
    *ngIf="contact" class="fixed inset-0 flex items-center z-30 justify-center bg-main-background bg-opacity-75"
    (click)="$event.preventDefault(); closeContactInfo();"
>
    <div class="bg-white w-full max-w-screen-md p-6 rounded-md shadow-lg text-center" (click)="$event.stopPropagation()">
        <table class="w-full text-left">
            <thead class="oswald-font text-gray-700 uppercase bg-main-background">
                <tr>
                    <th scope="col" class="px-6 py-3">Name</th>
                    <th scope="col" class="px-6 py-3">Title</th>
                    <th scope="col" class="px-6 py-3">Email</th>
                    <th scope="col" class="px-6 py-3">Work Phone</th>
                </tr>
            </thead>
            <tbody>
                <tr class="bg-white border-b">
                    <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                        {{ contact.name }}
                    </th>
                    <td class="px-6 py-4">{{ contact.Title }}</td>
                    <td class="px-6 py-4">{{ contact.email }}</td>
                    <td class="px-6 py-4">{{ contact.workphone }}</td>
                </tr>
            </tbody>
        </table>
        <div class="mt-4 flex justify-end gap-4">
            <button
                class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                (click)="$event.preventDefault(); closeContactInfo();"
            >
                Close
            </button>
        </div>
    </div>
</div>
